import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { ApplicationState } from 'AppReducer'

import Audio from 'util/modules/Audio/Audio'
import { uploadConversationFiles } from './_functions'
import { MessageAttachmentType } from 'util/services/upload'

const AudioAttachment: React.FC = () => {
  const dispatch = useDispatch()

  const { id } = useParams<{ id: string }>()
  const { selected } = useSelector((state: ApplicationState) => state.storeReducer)

  async function handleSubmit (file: File): Promise<void> {
    if (id && selected) {
      await uploadConversationFiles({
        files: [{ file, name: file.name, uri: '' }],
        type: MessageAttachmentType.AUDIO,
        storeId: selected,
        conversationId: Number(id)
      })(dispatch)
    }
  }

  return (
    <Audio onRecord={handleSubmit} />
  )
}

export default AudioAttachment
